import classNames from "classnames/bind";
import { forwardRef } from "react";
import { motion } from "motion/react";
import SecondaryLink from "../../SecondaryLink/SecondaryLink";
import { GetPageWrapperDataQuery } from "@graphqlTypes";
import LanguageRadioSelect from "../../LanguageRadioSelect/LanguageRadioSelect";

import styles from './TabletSideMenu.module.scss';
const cx = classNames.bind(styles);

type SideMenuProps = SiteNavigation["navigationSettingsFields"] & {
  languages: GetPageWrapperDataQuery["languages"];
};

const TabletSideMenu = forwardRef<HTMLDivElement, SideMenuProps>((props, ref) => {
  const { membershipLink, donateLink, hostEventLink, languages } = props;
  return (
    <div className={cx("tablet-side-menu")} ref={ref}>
      <div className={cx("links")}>
        <SecondaryLink {...membershipLink} className={cx("link")} />
        <SecondaryLink {...donateLink} className={cx("link")} />
        <SecondaryLink {...hostEventLink} className={cx("link")} />
      </div>
      <LanguageRadioSelect languages={languages} />
    </div>
  )
});

export default motion.create(TabletSideMenu);